import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPrintUploadPreview } from '@shared/modules/print-file-shared/interfaces/print-upload-preview';

@Component({
  selector: 'app-multiprint-second-step',
  templateUrl: './multiprint-second-step.component.html',
  styleUrls: ['./multiprint-second-step.component.scss']
})
export class MultiprintSecondStepComponent implements OnInit {
  @Input() uploadData!: IPrintUploadPreview
  @Output() finishStep = new EventEmitter<void>();
  @Output() goBackStep = new EventEmitter<void>();

  trackByFn(index: number, item: any) {
    return item.id;
  }

  constructor() { }

  ngOnInit(): void {
  }

  nextStep() {
    this.finishStep.next();
  }

  goBack(){
    this.goBackStep.next();
  }
}
